import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Card, Checkbox, Chip, Divider, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, ListItemIcon, Menu, MenuItem, OutlinedInput, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { v4 } from "uuid";
import { useMoeda } from "../../../core/hooks/useMoeda";
import { useCadastrarEditarProdutoContext } from "../../contexts/CadastrarEditarProdutoContext";
import { ButtonsContainer, ButtonsContainerForm, ConfiguracaoSabores, FiltroContainer, FormularioCard, TabelaVazia } from "./styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTamanhoTela } from '../../../core/hooks/useTamanhoTela';
import { ISabor } from '../../interfaces/ISabor';
import { saborSchema } from '../../schema/saborSchema';
import { FormularioSabor } from './containers/FormularioSabor';
import { Add, ArrowDownward, ArrowDropDown, ArrowUpward, PowerSettingsNew } from '@mui/icons-material';
import { ConfirmacaoAcaoModal } from '../../../core/components/ConfirmacaoAcaoModal';
import { ModalAtualizaPreco } from '../ModalAtualizarPreco';
import { Kitchen } from '@mui/icons-material';
import { useProdutos } from '../../hooks/useProdutos';
import { IProduto } from '../../interfaces/IProduto';
import { MenuOrdenacao } from '../../components/MenuOrdenacao';

type Tabs = "tabela" | "formulario";

interface ConfiguracaoSaboresContainerProps { }

export const ConfiguracaoSaboresContainer = ({ }: ConfiguracaoSaboresContainerProps) => {
    const [saboresSelecionados, setSaboresSelecionados] = useState<string[]>([]);
    const [filtroSabores, setFiltroSabores] = useState("");
    const { sabores, adicionarSabor, excluirSabor, editarSabor, ordenarSabores, trocarPosicaoSabor, handleProximo, handleVoltar, produto, categoriaUuid } = useCadastrarEditarProdutoContext();
    const [tab, setTab] = useState<Tabs>("tabela");
    const [saborEdicao, setSaborEdicao] = useState<ISabor | undefined>(undefined)
    const [confirmacaoExclusao, setConfirmacaoExclusao] = useState<boolean>(false);
    const [atualizacaoPreco, setAtualizacaoPreco] = useState<boolean>(false);
    const { number, real } = useMoeda();
    const { modeloTela } = useTamanhoTela();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { salvar } = useProdutos();

    const handleAbrirAtualizacaoPreco = () => {
        setAtualizacaoPreco(true);
        handleClose();
    }

    const handleFecharAtualizacaoPreco = () => {
        setAtualizacaoPreco(false);
    }

    const handleAtualizarPreco = (preco: string) => {
        saboresSelecionados?.map(uuidSabor => {
            const sabor = sabores?.find(sabor => sabor.uuid == uuidSabor);
            if (sabor) {
                editarSabor({
                    ...sabor,
                    preco: number(preco)
                });
            }
        })

        handleFecharAtualizacaoPreco();
        limparSaboresSelecionados();
    }

    const limparSaboresSelecionados = () => {
        setSaboresSelecionados([]);
    }

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleTab = (tab: Tabs) => {
        setTab(tab)
        setSaborEdicao(undefined);
        limparSaboresSelecionados();
    }

    const handleExcluirSabores = async () => {
        saboresSelecionados?.map(uuidSabor => {
            const sabor = sabores?.find(sabor => sabor.uuid == uuidSabor);
            if (sabor) {
                excluirSabor(sabor);
            }
        })
        handleFecharExclusao();
        limparSaboresSelecionados();
    }

    const handleAbrirExclusao = async () => {
        setConfirmacaoExclusao(true);
        handleClose();
    }

    const handleFecharExclusao = async () => {
        setConfirmacaoExclusao(false);
    }

    const handleAbrirEdicao = (sabor: ISabor) => {
        setTab("formulario");
        setSaborEdicao(sabor);
        handleClose();
    }

    const handleToggleAtivacao = async (sabor: ISabor) => {
        if (!produto || !categoriaUuid) return;
        const saborAtualizado: ISabor = { ...sabor, inativadoAs: sabor.inativadoAs ? undefined : new Date() };
        editarSabor(saborAtualizado);
        await salvar(categoriaUuid, {
            ...produto,
            sabores: sabores.map(s => s.uuid === sabor.uuid ? saborAtualizado : s)
        } as IProduto);
        handleClose();
    }

    const toggleSelecionado = (uuid: string) => {
        setSaboresSelecionados(prev =>
            prev.includes(uuid) ? prev.filter(id => id !== uuid) : [...prev, uuid]
        );
    };

    const toggleSelecionarTodos = () => {
        if (saboresSelecionados.length === sabores.length) {
            limparSaboresSelecionados();
        } else {
            setSaboresSelecionados(sabores.map(sabor => sabor.uuid));
        }
    };


    /** Posição no array que vai ser salvo — a linha pode vir da lista filtrada. */
    const indiceOrdem = (uuid: string) => sabores.findIndex(s => s.uuid === uuid);

    const renderizarLinha = (sabor: ISabor) => (
        <TableRow key={sabor.uuid} sx={{ opacity: sabor.inativadoAs ? 0.5 : 1 }}>
            <TableCell align="center">
                <Checkbox
                    checked={saboresSelecionados.includes(sabor.uuid)}
                    onChange={() => toggleSelecionado(sabor.uuid)}
                />
            </TableCell>
            <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                <Tooltip title={filtroSabores ? "Limpe o filtro para reordenar" : "Mover para cima"}>
                    <span>
                        <IconButton
                            size="small"
                            disabled={!!filtroSabores || indiceOrdem(sabor.uuid) <= 0}
                            onClick={() => trocarPosicaoSabor(sabor.uuid, "cima")}
                        >
                            <ArrowUpward fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title={filtroSabores ? "Limpe o filtro para reordenar" : "Mover para baixo"}>
                    <span>
                        <IconButton
                            size="small"
                            disabled={!!filtroSabores || indiceOrdem(sabor.uuid) === sabores.length - 1}
                            onClick={() => trocarPosicaoSabor(sabor.uuid, "baixo")}
                        >
                            <ArrowDownward fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell align="center">
                <img alt={sabor.descricao} src={
                    sabor?.imagens?.length
                        ? sabor?.imagens[0] instanceof File ? URL.createObjectURL(sabor?.imagens[0]) : sabor?.imagens[0].url
                        : `${process.env.PUBLIC_URL}/images/produtos/generico.png`
                } style={{
                    width: "60px",
                    height: "50px",
                    borderRadius: "5px"
                }} />
            </TableCell>
            <TableCell align="center">
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    textAlign: 'left'
                }}>
                    <Typography fontSize={14}>
                        {sabor.descricao}
                    </Typography>
                    {sabor.detalhes && (
                        <Typography color={"GrayText"} fontSize={10}>
                            {sabor.detalhes?.length > 35 ? `${sabor.detalhes?.slice(0, 35)}...` : sabor.detalhes}
                        </Typography>
                    )}
                </Box>
            </TableCell>
            <TableCell align="center">
                <Typography fontSize={13}>
                    {real(sabor.preco)}
                </Typography>
            </TableCell>
            <TableCell align="center">
                <Tooltip title={sabor.processosPreparoKDS?.length ? `${sabor.processosPreparoKDS.length} processo(s) KDS` : 'Sem KDS configurado'}>
                    <Kitchen fontSize="small" color={sabor.processosPreparoKDS?.length ? 'primary' : 'disabled'} />
                </Tooltip>
            </TableCell>
            <TableCell align="center">
                <Chip
                    label={sabor.inativadoAs ? "Inativo" : "Ativo"}
                    color={sabor.inativadoAs ? "default" : "success"}
                    size="small"
                />
            </TableCell>
        </TableRow>
    );

    return (
        <ConfiguracaoSabores>
            {tab == "tabela" && (
                <TableContainer component={Paper} variant='outlined' sx={{
                    width: "100%",
                    maxHeight: 450,
                    height: "100%",
                    minHeight: 350
                }}>
                    <Toolbar
                        sx={{
                            pl: { sm: 2 },
                            pr: { xs: 1, sm: 1 },
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                        <Typography variant="h6">
                            Sabores
                        </Typography>
                        <FiltroContainer>
                            {modeloTela == "desktop" && (
                                <TextField
                                    placeholder='Nome'
                                    size='small'
                                    value={filtroSabores}
                                    onChange={(e) => setFiltroSabores(e.target.value)}
                                    sx={{ width: "200px" }}
                                />
                            )}
                            <Box>
                                <Button
                                    onClick={handleClick}
                                    endIcon={<ArrowDropDown />}
                                    variant="contained"
                                    disabled={saboresSelecionados.length <= 0}
                                >
                                    Ações
                                </Button>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    <MenuItem disabled>
                                        <Typography variant="inherit" noWrap>
                                            {saboresSelecionados.length} {saboresSelecionados.length === 1 ? "sabor selecionado" : "sabores selecionados"}
                                        </Typography>
                                    </MenuItem>
                                    <Divider />
                                    <Tooltip title={saboresSelecionados?.length <= 1 ? 'Editar' : 'Alterar preço'}>
                                        <MenuItem disabled={saboresSelecionados?.length == 0} onClick={() => {
                                            if (saboresSelecionados?.length == 1) {
                                                const sabor = sabores?.find(sabor => sabor.uuid == saboresSelecionados[0])
                                                if (sabor) {
                                                    return handleAbrirEdicao(sabor);
                                                }
                                            }
                                            handleAbrirAtualizacaoPreco();
                                        }}>
                                            <ListItemIcon>
                                                <EditIcon fontSize="small" />
                                            </ListItemIcon>
                                            <Typography variant="inherit" noWrap>
                                                {saboresSelecionados?.length <= 1 ? 'Editar' : 'Alterar preço'}
                                            </Typography>
                                        </MenuItem>
                                    </Tooltip>
                                    <Tooltip title={saboresSelecionados?.length == 1 ? `Excluir sabor` : `Excluir sabores`}>
                                        <MenuItem onClick={handleAbrirExclusao} disabled={saboresSelecionados?.length == 0}>
                                            <ListItemIcon>
                                                <DeleteIcon fontSize="small" />
                                            </ListItemIcon>
                                            <Typography variant="inherit" noWrap>
                                                Excluir
                                            </Typography>
                                        </MenuItem>
                                    </Tooltip>
                                    <MenuItem disabled={saboresSelecionados?.length !== 1} onClick={() => {
                                        const sabor = sabores?.find(s => s.uuid == saboresSelecionados[0]);
                                        if (sabor) handleToggleAtivacao(sabor);
                                    }}>
                                        <ListItemIcon>
                                            <PowerSettingsNew fontSize="small" />
                                        </ListItemIcon>
                                        <Typography variant="inherit" noWrap>
                                            {saboresSelecionados?.length === 1 && sabores.find(s => s.uuid === saboresSelecionados[0])?.inativadoAs ? 'Ativar' : 'Inativar'}
                                        </Typography>
                                    </MenuItem>
                                </Menu>
                            </Box>
                            <MenuOrdenacao
                                titulo="Ordenar sabores"
                                desabilitado={sabores.length <= 1}
                                ordenar={(direcao) => {
                                    ordenarSabores(direcao);
                                    limparSaboresSelecionados();
                                }}
                            />
                            <Tooltip title='Crie um novo sabor'>
                                <IconButton color="primary" onClick={() => handleTab("formulario")}>
                                    <Add />
                                </IconButton>
                            </Tooltip>
                        </FiltroContainer>
                    </Toolbar>
                    {sabores.length ? (
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">
                                        <Checkbox
                                            checked={saboresSelecionados.length === sabores.length && sabores.length > 0}
                                            indeterminate={saboresSelecionados.length > 0 && saboresSelecionados.length < sabores.length}
                                            onChange={toggleSelecionarTodos}
                                        />

                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip title="Define a ordem em que aparece no cardápio, no PDV e no chat. Salve o produto para gravar.">
                                            <span>Ordem</span>
                                        </Tooltip>
                                    </TableCell>
                                    <TableCell align="center">Imagem</TableCell>
                                    <TableCell align="center">Nome</TableCell>
                                    <TableCell align="center">Preço</TableCell>
                                    <TableCell align="center">KDS</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filtroSabores
                                    ? sabores.filter(sabor => sabor.descricao.toLowerCase().includes(filtroSabores.toLocaleLowerCase())).map(sabor => {
                                        return renderizarLinha(sabor);
                                    })
                                    : sabores.map(sabor => {
                                        return renderizarLinha(sabor);
                                    })}

                            </TableBody>
                        </Table>
                    ) : (
                        <TabelaVazia>
                            Nenhum sabor cadastrado
                        </TabelaVazia>
                    )}
                </TableContainer>
            )}
            {tab == "formulario" && <FormularioSabor
                adicionarSabor={adicionarSabor}
                editarSabor={editarSabor}
                handleTab={handleTab}
                saborEdicao={saborEdicao}
            />}
            {tab == "tabela" && (
                <ButtonsContainerForm>
                    <Button size="medium" variant="outlined" onClick={handleVoltar}>
                        Voltar
                    </Button>
                    <Button size="medium" variant="contained" onClick={handleProximo}>
                        Próximo
                    </Button>
                </ButtonsContainerForm>
            )}
            <ConfirmacaoAcaoModal
                open={confirmacaoExclusao}
                descricao={saboresSelecionados?.length == 1
                    ? `Você deseja excluir o sabor selecionado?`
                    : `Você deseja excluir os ${saboresSelecionados?.length} sabores selecionados?`
                }
                titulo={saboresSelecionados?.length == 1 ? `Excluir sabor` : `Excluir sabores`}
                onCancelar={handleFecharExclusao}
                onConfirmar={handleExcluirSabores}
            />
            <ModalAtualizaPreco
                aberto={atualizacaoPreco}
                fechar={handleFecharAtualizacaoPreco}
                atualizar={handleAtualizarPreco}
            />
        </ConfiguracaoSabores>
    )
}